import { createFileRoute } from '@tanstack/react-router';
import Security from 'containers/Security';

export const Route = createFileRoute('/_authenticated/security')({
  component: Security,
});
